import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
// import Breadcrumb from "../components/Breadcrumb";
import EventManagerBookingsLayer from "../components/EventManagerBookingsLayer";

const EventManagerBookingsPage = () => {
  return (
    <>
      <MasterLayout>
        {/* <Breadcrumb title="Event Manager Bookings" /> */}
        <EventManagerBookingsLayer />
      </MasterLayout>
    </>
  );
};

export default EventManagerBookingsPage;
